import * as yup from 'yup'

export const reportPostSchema = yup
  .object({
    message: yup.string().required(),
  })
  .required()
